import { useMutation, useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { forgotPassword, getAllUsersWithSearch, getCurrentUserProfile } from '../api/user';

export const useCurrentUserProfile = () => {
  const isTokenStored = !!localStorage.getItem('token');

  const { data, isLoading, error, refetch, isFetched } = useQuery({
    queryKey: ['Current-User'],
    queryFn: getCurrentUserProfile,
    enabled: isTokenStored,
  });

  return {
    data,
    isLoading,
    error,
    refetch,
    isFetched,
  };
};

export const useForgotPassword = () => {
  const {
    mutate,
    isPending: isLoading,
    error,
  } = useMutation({
    mutationKey: ['forgot-password'],
    mutationFn: (userInfo) => forgotPassword(userInfo),

    onSuccess: (data) => {
      toast.success(data?.message, {
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    },

    onError: (e) => {
      toast.error(e?.message, {
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    },
  });

  return { mutate, isLoading, error };
};

export const useUsersSearch = (search) => {
  const { data, isLoading, error, refetch, isFetched } = useQuery({
    queryKey: ['users', search],
    queryFn: () => getAllUsersWithSearch(search, 'true'),
    enabled: !!search,
  });

  return {
    data,
    isLoading,
    error,
    refetch,
    isFetched,
  };
};
